jQuery( document ).ready(function() {
  initfavoriteJobs();
});

function initfavoriteJobs() {

  bindFavoritesEvents();
  if (jobsListingManager) {
    jobsListingManager.postLoadedCallback = bindFavoritesEvents;
  }
  
}

function bindFavoritesEvents() {

    var likedSvg = 'Baraud_ICON_Liked.svg';
    var unlikedSvg = 'Baraud_ICON_NotLiked.svg';
    var jobBoxContent = jQuery('.job-box-content');

    jobBoxContent.on('click', function (e) {
      if (e.target.classList.contains('like-btn')) {
        e.preventDefault();
      }
    });

    jQuery('.like-btn').on( "click", function(e) {

        var post_id = jQuery(this).parent().find('.favorite-job-id').val();

        if ( jQuery( this ).attr('src') === favoriteSvgUrl + unlikedSvg ) {

          jQuery( this ).attr('src',  favoriteSvgUrl + likedSvg);

        } else {

          jQuery( this ).attr('src',  favoriteSvgUrl + unlikedSvg);
        }

        jQuery.ajax({

            url: ajaxurl,
            data : {
              action : 'stock_favorite_jobs',
              post_id : post_id
            },
            type: 'POST',
            beforeSend:function(xhr){
            },
            error: function(e) {
                console.log(e);
            },
            success:function(data) {
              jQuery( this ).attr('src',  favoriteSvgUrl + likedSvg);
              console.log(data);
            }
        });
    });
}
